import {
  TRAINING_OBJECTIVES_SET,
  TRAINING_OBJECTIVE_ADDED,
  TRAINING_OBJECTIVE_DELETED,
  TRAINING_OBJECTIVE_EDITED,
} from 'src/app/redux/redux-types';
import { reduxTrainingObjectiveTypes } from 'src/types';

export const trainingObjectiveDefaultState: reduxTrainingObjectiveTypes.StateType = {
  trainingObjectiveList: [],
};

export const trainingObjectiveReducer = (
  state = trainingObjectiveDefaultState,
  action: reduxTrainingObjectiveTypes.ActionType,
): reduxTrainingObjectiveTypes.StateType => {
  switch (action.type) {
    case TRAINING_OBJECTIVES_SET:
      return {
        ...state,
        trainingObjectiveList: action.payload,
      };
    case TRAINING_OBJECTIVE_ADDED:
      // eslint-disable-next-line no-case-declarations
      const exists = state.trainingObjectiveList.some((item) => item.id === action.payload.id);
      if (exists) {
        return state;
      }
      return {
        ...state,
        trainingObjectiveList: [action.payload, ...state.trainingObjectiveList],
      };
    case TRAINING_OBJECTIVE_EDITED:
      // eslint-disable-next-line no-case-declarations
      const updateIndex = state.trainingObjectiveList.findIndex((obj) => obj.id === action.payload.id);
      return {
        ...state,
        trainingObjectiveList: [
          ...state.trainingObjectiveList.slice(0, updateIndex),
          action.payload,
          ...state.trainingObjectiveList.slice(updateIndex + 1),
        ],
      };
    case TRAINING_OBJECTIVE_DELETED:
      return {
        ...state,
        trainingObjectiveList: state.trainingObjectiveList.filter((o) => o.id !== action.payload),
      };
    default:
      return state;
  }
};
